module.exports = __webpack_public_path__ + "static/media/1009770.fd55fb44.jpg";